// Route registration only — component body lives in dashboard.salary-insights.lazy.tsx
// (Phase Bundle-Splitting-1: keep the SalaryInsightsEurope import out of the initial bundle).
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$locale/dashboard/salary-insights')({
  ssr: false,
})
